import { apiSlice } from '../api/api-slice';
import { SplittingRoutingPartnerInfoViewModel, PaginatedResult } from '../api/models';

export interface SplittingRoutingPartnerInfoListRequest {
  pageSize: number;
  filter?: string | null;
  current: number;
  total?: number;
  sortBy?: string | null;
  sortColumn?: string | null;
  sortDirection?: string | null;
  searchText?: string | null;
  filterJson?: string | null;
}

export const splittingroutingpartnerinfoApi = apiSlice.injectEndpoints({
  
  endpoints(builder) {
    return {
      fetchSplittingRoutingPartnerInfo: builder.query<PaginatedResult<SplittingRoutingPartnerInfoViewModel>, SplittingRoutingPartnerInfoListRequest>({
        query({ current, pageSize, filter, sortColumn, sortDirection, searchText, filterJson }) {
          const params = new URLSearchParams();
          params.append('pageNumber', current.toString());
          params.append('pageSize', pageSize.toString());
          if (sortColumn) params.append('sortColumn', sortColumn);
          if (sortDirection) params.append('sortDirection', sortDirection);
          if (searchText) params.append('searchText', searchText);
          if (filterJson) {
            params.append('filterJson', filterJson);
          }
          if (filter) params.append('filter', filter);
          // Note: This API uses sortColumn and sortDirection, not sortBy

          return `/RoutingRules/splitting-routing-partner-info?${params.toString()}`;
        },
        forceRefetch({ currentArg, previousArg }) {
         return true;
        },
        providesTags: (data, _error, arg) =>
        [
          'SplittingRoutingPartnerInfo',
          ...(data?.results?.map(({ partnerId }) => ({ type: 'SplittingRoutingPartnerInfo' as const, id: `${partnerId}` })) || [])
        ] 
      }),
    };    
  },
});

export const {
  useFetchSplittingRoutingPartnerInfoQuery,
} = splittingroutingpartnerinfoApi;

